import {Breadcrumbs} from '@management-ui/core';
import {Paper} from '@mui/material';
import * as React from 'react';
import Table from './Table';

const Vehicles = () => {
  return (
    <div>
      <Breadcrumbs crumbs={[{title: 'Vehicles'}]}/>
      <Paper>
        <Table/>
      </Paper>
    </div>
  );
};

export default Vehicles;
